import { useQuery } from '@tanstack/react-query';
import { getMapData } from '../../../api/map';

export function useMapData(childId) {
  return useQuery({
    queryKey: ['mapData', childId],
    queryFn: () => getMapData(childId),
    enabled: !!childId,
    staleTime: 60_000,
    gcTime: 5 * 60_000,
  });
}
